"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateWarnMessage = void 0;
var generateWarnMessage = exports.generateWarnMessage = function generateWarnMessage(apiFuncName, args, error) {
  return "window.ClientProfiler.".concat(apiFuncName, "(").concat(args.join(','), ") failed: ").concat(error);
};